@if (participant) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img
        class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()"
        />
      </div>
      <div class="dialogContent">
        @if (participant.id == 0 && !multiEditMode) {
          <div>
            <app-dialog-input-title
              title="Kursus"
              [required]="true"
            ></app-dialog-input-title>
            <select
              class="dialogDropdown"
              [(ngModel)]="participant.courseId"
              (ngModelChange)="onCourseChanged()"
              >
              <option value="0" class="hidden">Vælg kursus</option>
              @for (course of allCourses; track course) {
                <option [value]="course.id">
                  {{ course.name }}
                </option>
              }
            </select>
          </div>
        } @else {
          @if (!multiEditMode) {
            <div class="underline">
              <app-dialog-input-title
                class="underline"
                [title]="participant.course!.name"
              ></app-dialog-input-title>
              <p>{{ participant.user!.name }}</p>
            </div>
          }
        }
        @if (
          participant.id == 0 &&
          !multiEditMode &&
          this.userService.getSelectedRole !=
          this.userService.getUserRoleTypes.User
          ) {
          <div
            >
            <app-dialog-input-title
              title="Bruger(e)"
              [required]="true"
            ></app-dialog-input-title>
            <input
              type="text"
              class="Textbox"
              placeholder="Søg bruger"
              (input)="searchForUser($event)"
              />
              <br />
              <br />
              @if (!multiEditMode) {
                <div class="participantsContainer">
                  @for (userParticipant of searchedUsers; track userParticipant) {
                    <div
                      class="participant"
                      (click)="refreshParticipating(userParticipant)"
                      >
                      <p>{{ userParticipant.name }}</p>
                      <input type="checkbox" [(ngModel)]="userParticipant.participating" />
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div>
            <app-dialog-input-title
              title="Status"
              [required]="true"
            ></app-dialog-input-title>
            <div>
              @if (!courseProgressIsExpired) {
                <div>
                  <select
                    [(ngModel)]="selectedProgress.courseProgressName"
                    class="dialogDropdown"
                    [disabled]="selectedProgress.id !== currentStatusId"
                    >
                    @for (status of selectableCourseProgressNameType | keyvalue; track status) {
                      <option
                        [value]="status.key"
                        >
                        {{ courseProgressTranslations[status.value] }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (courseProgressIsExpired) {
                <div>Kurset er udløbet</div>
              }
            </div>
          </div>
          @if (
            selectedProgress.courseProgressName == courseProgressNameType.Enrolled) {
            <div>
              <app-dialog-input-title
                title="Deadline"
                [required]="true"
              ></app-dialog-input-title>
              <mat-form-field
                (click)="picker.open()"
                color="accent"
                class="dialogDatepicker"
                >
                <input
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="selectedProgress.deadline"
                  [disabled]="selectedProgress.id !== currentStatusId"
                  name="completionDate"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                </mat-form-field>
              </div>
            } @else {
              <app-dialog-input-title
                title="Udførselsdato"
                [required]="true"
              ></app-dialog-input-title>
              <mat-form-field
                (click)="picker.open()"
                color="accent"
                class="dialogDatepicker"
                >
                <input
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="selectedProgress.completionDate"
                  name="completionDate"
          [disabled]="
            courseProgressIsExpired || selectedProgress.id !== currentStatusId
          "
                  (ngModelChange)="onCourseChanged()"
                  />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                    [disabled]="courseProgressIsExpired"
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <nav></nav>
                </mat-form-field>
                @if (selectedProgress.expiryDate != undefined && !multiEditMode) {
                  <div>
                    <app-dialog-input-title
                      title="Udløbsdato"
                      [required]="true"
                    ></app-dialog-input-title>
                    <div></div>
                    <mat-form-field class="dialogDatepicker">
                      <input
                        matInput
                        [matDatepicker]="expiryPicker"
                        [value]="selectedProgress.expiryDate"
                        name="expiryDate"
                        readonly
                        (ngModelChange)="onCourseChanged()"
                        disabled
                        />
                        <mat-datepicker-toggle matIconSuffix [for]="expiryPicker" disabled>
                        </mat-datepicker-toggle>
                        <mat-datepicker #expiryPicker> </mat-datepicker>
                      </mat-form-field>
                    </div>
                  }
                }
                @if (
                  selectedProgress.courseProgressName == courseProgressNameType.Completed
                  ) {
                  <div
                    >
                    <input
                      #fileUpload
                      type="file"
                      id="fileUpload"
                      class="file-input"
                      requiredFileType=".pdf/image/png"
                      (change)="onFileSelected($event)"
                      />
                      <div>
                        @if (isEditingMultipleParticipants()) {
                          <span>
                            Man kan ikke uploade kursusbevis, når der er valgt mere end 1
                            deltager/tilmelding.
                          </span>
                        }
                        <app-dialog-input-title title="Kursusbevis"></app-dialog-input-title>
                        <div class="dialogCertificate">
                          <div class="certificateContainer">
                            @if (!isEditingMultipleParticipants()) {
                              <div
                                class="certificateButtonsContainer"
                                >
                                <button
                                  mat-flat-button
                                  class="dialogButton"
                                  color="accent"
                                  (click)="uploadFile()"
                                  >
                                  Upload
                                  <img src="/images/uploadIcon.svg" class="IconButton" />
                                </button>
                                @if (
                                  this.selectedProgress.certificateContentType != undefined
                                  ) {
                                  <button
                                    mat-flat-button
                                    class="dialogButton"
                                    color="accent"
                                    (click)="downloadFile()"
                                    >
                                    Download
                                    <img src="/images/downloadIcon.svg" class="IconButton" />
                                  </button>
                                }
                                @if (
                                  this.selectedProgress.certificateContentType != undefined
                                  ) {
                                  <button
                                    mat-flat-button
                                    class="dialogButton"
                                    color="primary"
                                    (click)="deleteCertificate()"
                                    >
                                    Slet kursusbevis
                                  </button>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (
                    participant.courseProgresses &&
                    participant.courseProgresses.length > 1 &&
                    !multiEditMode
                    ) {
                    <div
                      >
                      <app-dialog-input-title title="Kursus historik"></app-dialog-input-title>
                      <div class="dialogFooter">
                        <div class="dialogHistory">
                          <div class="historyContainer">
                            <div class="historyButtonContainer">
                              @for (progress of participant.courseProgresses; track progress) {
                                <button
                                  mat-flat-button
                                  class="historyButton"
                                  color="accent"
                [ngClass]="{
                  'green-button': selectedProgress.id === progress.id
                }"
                                  (click)="onStatusChange(progress)"
                                  style="text-align: center"
                                  >
                                  {{ progress.statusDateTime | date : "dd-MM-yyyy" }}
                                </button>
                              }
                            </div>
                          </div>
                          <button
                            mat-flat-button
                            class="dialogButton justifySelf"
                            color="primary"
                            (click)="deleteHistory()"
                            >
                            Slet hele historik
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="saveDeleteButton">
                    <app-save-button
                      [disabled]="canSaveParticipant()"
                      [clickEvent]="saveChanges.bind(this)"
                      >
                    </app-save-button>
                    @if (participant.userId != 0 || multiEditMode) {
                      <app-delete-button
                        [textContent]="deleteCourseProgressButtonText()"
                        [clickEvent]="deleteParticipation.bind(this)"
                        >
                      </app-delete-button>
                    }
                  </div>
                </div>
              </div>
            }
